const PREFIX = "thegame:";
const KEY_MESSAGING_TOKEN = `${PREFIX}messagingToken`;

const setLS = (key, value) =>
    localStorage && localStorage.setItem(key, JSON.stringify(value));

const getLS = key => {
    if (!localStorage) {
        return null;
    }
    const val = localStorage.getItem(key);
    if (val) {
        try {
            return JSON.parse(val);
        } catch (ignored) {
        }
    }
    return val;
};

const removeLS = key =>
    localStorage && localStorage.removeItem(key);

export default {
    setMessagingToken: token => setLS(KEY_MESSAGING_TOKEN, token),
    clearMessagingToken: () => removeLS(KEY_MESSAGING_TOKEN),
    getMessagingToken: () => getLS(KEY_MESSAGING_TOKEN),
};



// WEBPACK FOOTER //
// ./src/util/LocalStorage.js